import { getAdId, getUserId } from './cookie';
import { setupFinnGlobalVar } from './finn';
import { getFeatureStatus } from '../config';
import { initApnListeners, trackContentboard } from './listeners';
import { AppNexusData, Apntag, PageOpts } from '../../shared/types/ast';
import { markSetPageOpts, markTagsLoaded } from './performance';
import { Feed } from '../../shared/types/reklameMaster';

export { initTakeover, injectTakeoverTemplate, isTakeover } from './takeover';

function setExternalUid(pageOpts: PageOpts, enableNRM: boolean) {
    const enableUpdatedKeyword = getFeatureStatus(
        'enableUpdatedExternalIdKeyword',
    );
    if (pageOpts) {
        const userId = getAdId();
        const extId = getUserId();
        let idSrc = '0';
        pageOpts.user = {};
        pageOpts.user.externalUid = userId;
        if (userId) {
            idSrc = extId ? '2' : '1';
        }
        pageOpts.keywords = pageOpts.keywords || {};
        if (!enableNRM) {
            const externalIdKey = enableUpdatedKeyword
                ? 'aa-sch-externalid_src'
                : 'no-generic-externalid_src';
            pageOpts.keywords[externalIdKey] = idSrc;
        }

        if (
            userId === 'DO_NOT_TRACK' ||
            (navigator && navigator.doNotTrack === '1')
        ) {
            pageOpts.user.dnt = true;
        }
    }
    return pageOpts;
}

export function requestBanners(
    apntag: Apntag,
    appNexusData: AppNexusData,
    loadTags = true,
    addListeners = true,
    enableNRM: boolean,
    nrmFeed: Feed = {},
    nrmFeedString: string = '',
) {
    if (apntag && apntag.anq && appNexusData) {
        if (enableNRM) {
            appNexusData.feed = nrmFeed as {
                [key: string]: string;
            };
            appNexusData.feedString = nrmFeedString;
        }

        apntag.anq.push(() => {
            setupFinnGlobalVar(appNexusData);
            const pageOptsWithUserId = setExternalUid(
                appNexusData.pageOpts,
                enableNRM,
            );
            markSetPageOpts();
            apntag.setPageOpts(pageOptsWithUserId);
            if (loadTags) {
                Object.values(appNexusData.tags).forEach(apntag.defineTag);
                markTagsLoaded();
                apntag.loadTags();
            }
            if (addListeners) {
                initApnListeners(apntag, appNexusData);
            }
        });
    }
}

export { initApnListeners, trackContentboard };
